import { Button } from "antd";
import { PlusFill } from "themes/Icon";
import "./button.scss";

function ButtonComp({
  children,
  href,
  icon,
  prefix,
  wFull,
  rounded,
  variant = "primary",
  bgNone,
  className,
  height = 42,
  onClick,
  loading,
  width,
  disabled = false,
  ...props
}) {
  return (
    <Button
      onClick={onClick}
      block={wFull}
      loading={loading}
      disabled={disabled}
      icon={icon}
      iconPosition={"end"}
      type={variant}
      href={href}
      shape={rounded && "circle"}
      style={{
        height: `${height}px`,
        minWidth: `${rounded && height}px`,
        maxWidth: `${rounded && height}px`,
        width: width,
      }}
      className={`${className ? className : ""} ${bgNone ? "bg-none" : ""}`}
      {...props}
    >
      {!icon && (
        <div className="child-container">
          {prefix && (
            <span className="prefix-icon">
              {prefix === true ? <PlusFill /> : prefix}
            </span>
          )}
          <span className="btn-text">{children}</span>
        </div>
      )}
    </Button>
  );
}

export default ButtonComp;
